import {
  resolveLegacyRolesForMemberInJoinedTeams,
  resolveLegacyRolesForActiveMember,
  resolveLegacyRoles,
} from '../components/teams/utils';

export default {
  FORM_RECAPTCHA_SITE_KEY_V3: window.FORM_RECAPTCHA_SITE_KEY_V3,
  AUTH_RECAPTCHA_SITE_KEY_V3: window.AUTH_RECAPTCHA_SITE_KEY_V3,
  GOOGLE_AUTH_CLIENT_ID: window.GOOGLE_AUTH_CLIENT_ID,
  TOKEN: window.TOKEN,
  EMAIL: window.EMAIL,
  USER_ID: window.USER_ID,
  GUSER_ID: window.GUSER_ID,
  IS_BETA: window.IS_BETA,
  PRODUCTION: window.PRODUCTION,
  BETA_FEEDBACK_FORM_ID: window.BETA_FEEDBACK_FORM_ID,
  PLAN: window.PLAN,
  PAYMENT_DETAILS: window.PAYMENT_DETAILS,
  TIMEZONE: window.TIMEZONE,
  RESULTS_IN_DATASTORE: window.RESULTS_IN_DATASTORE,
  USER_INFO: window.user_info,
  OLD_USER: window.OLD_USER,

  PERMS: window.PERMS,
  ROLES: window.ROLES,
  TEAMS: resolveLegacyRolesForMemberInJoinedTeams(window.TEAMS),
  ACTIVE_TEAM: window.ACTIVE_TEAM,
  ACTIVE_NAME: window.ACTIVE_NAME,
  DISPLAY_ROLES: resolveLegacyRoles(window.DISPLAY_ROLES),
  ACTIVE_MEMBER: resolveLegacyRolesForActiveMember(window.ACTIVE_MEMBER),
  ACTIVE_USER_ID: window.ACTIVE_USER_ID,

  VERSION_HASH: window.VERSION_HASH,
  PROJECT_ID: window.PROJECT_ID,
  SERVICE_NAME: window.SERVICE_NAME,
  BROWSER_KEY: window.firebaseConfig ? window.firebaseConfig.apikey : null,

  location: window.location,
  mixpanel: window.mixpanel,
  FIREBASE_CONFIG: window.firebaseConfig,
  errorReporter: window.errorReporter,
  stripMessage: window.stripMessage,
  isLoggedIn: window.isLoggedIn
};
